import EnumType from "./EnumType.js";

// Mirrors AEM.Geo.Business.SampleUnit; labels are the unit symbols (i18n "SampleUnit.n").
const values = {
  None: 0,
  Percent: 1,
  GramPerTon: 2,
  kCountPerSec: 3,
  kgPerM3: 4,
  mg: 5,
  ppm: 6,
  Unknown: 7,
  Gram: 8,
  Kilogram: 9
};

export default EnumType.generate(values, "SampleUnit.");
